exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/sidebar-menu/sidebar-menu.component.css
// module id = ../../../../../src/app/components/sidebar-menu/sidebar-menu.component.css
// module chunks = 0